function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
import { computed, defineComponent, onMounted, getCurrentInstance } from "vue";
import { archiveTypes } from "@/config/file-types";
import { getFileExtension } from "@com/utils/file";
import { t } from "@/lang";
import { unzip } from "@com/utils/zip-file";
import Uploader from "@/components/Uploader/index.vue";
import FileListItem from "./file-list-item.vue";
import { definePropType } from "@types-vue/props";
export default defineComponent({
    props: {
        multiple: {
            type: Boolean,
            default: true
        },
        fileList: {
            type: definePropType(Array),
            required: true
        }
    },
    components: {
        FileListItem: FileListItem,
        Uploader: Uploader
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var handleChange = function handleChange(files) {
            console.log("file change", files);
        };
        var validateFileSize = function validateFileSize(file) {
            // 模型最大支持 30M
            var size = 30 * 1024 * 1024;
            if (file.size > size) {
                setTimeout(function() {
                    root.$message.error(t("playTurbo.assetLibrary.asset.upload.errorFileSize", {
                        size: "30M"
                    }));
                }, 100);
                return false;
            }
            return true;
        };
        var handleFileProgress = function handleFileProgress(event, file, fileList) {
            console.log("file progress", file, JSON.stringify(fileList));
            uploadFileList.value = fileList;
        };
        var handleFileSuccess = function handleFileSuccess(response, file, fileList) {
            console.log("file success", file, JSON.stringify(fileList));
            uploadFileList.value = fileList;
        };
        var handlePreview = function handlePreview(file) {
            console.log("file handlePreview", file);
        };
        var handleFileRemoved = function handleFileRemoved(file, fileList) {
            console.log("file removed", file);
            uploadFileList.value = fileList;
        };
        var beforeRemove = function beforeRemove(file, fileList) {
            console.log("upload beforeRemove");
            uploadFileList.value = fileList;
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var uploadFileList = computed({
            get: function() {
                return props.fileList;
            },
            set: function(val) {
                emit("update:fileList", val);
            }
        });
        var uploaderAttr = computed(function() {
            return {
                accept: archiveTypes.zip.mediaTypes.join(),
                data: {
                    bucket: "mws-files",
                    unzip: 2
                },
                "show-file-list": false,
                drag: true,
                multiple: props.multiple,
                limit: props.multiple ? undefined : 1
            };
        });
        function validateFileType(file) {
            return _validateFileType.apply(this, arguments);
        }
        function _validateFileType() {
            _validateFileType = _asyncToGenerator(regeneratorRuntime.mark(function _callee(file) {
                var type, resZip;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            type = getFileExtension(file.name);
                            if (!(archiveTypes.zip.mediaTypes.indexOf(file.type) !== -1)) {
                                _ctx.next = 9;
                                break;
                            }
                            _ctx.next = 4;
                            return unzip({
                                file: file
                            }, {
                                file_type: "model"
                            });
                        case 4:
                            resZip = _ctx.sent;
                            if (!(resZip.type !== "model" || !resZip.valid)) {
                                _ctx.next = 8;
                                break;
                            }
                            root.$message.error(resZip.message || t("playTurbo.order.3dmodel.uploader.missModelFile"));
                            return _ctx.abrupt("return", false);
                        case 8:
                            return _ctx.abrupt("return", true);
                        case 9:
                            root.$message.error(t("playTurbo.assetLibrary.asset.upload.errorType", {
                                type: type
                            }));
                            return _ctx.abrupt("return", false);
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _validateFileType.apply(this, arguments);
        }
        function validateFile(file) {
            return _validateFile.apply(this, arguments);
        }
        function _validateFile() {
            _validateFile = _asyncToGenerator(regeneratorRuntime.mark(function _callee(file) {
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.t0 = validateFileSize(file);
                            if (!_ctx.t0) {
                                _ctx.next = 5;
                                break;
                            }
                            _ctx.next = 4;
                            return validateFileType(file);
                        case 4:
                            _ctx.t0 = _ctx.sent;
                        case 5:
                            return _ctx.abrupt("return", _ctx.t0);
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _validateFile.apply(this, arguments);
        }
        function beforeUpload(file) {
            return _beforeUpload.apply(this, arguments);
        }
        function _beforeUpload() {
            _beforeUpload = _asyncToGenerator(regeneratorRuntime.mark(function _callee(file) {
                var isValid;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return validateFile(file);
                        case 3:
                            isValid = _ctx.sent;
                            if (!isValid) {
                                _ctx.next = 7;
                                break;
                            }
                            console.log("\u6587\u4EF6\u6821\u9A8C\u901A\u8FC7\uFF0C\u5F00\u59CB\u4E0A\u4F20", file);
                            return _ctx.abrupt("return", Promise.resolve(true) // 返回 Promise 并 resolve
                            );
                        case 7:
                            return _ctx.abrupt("return", Promise.reject(false) // 返回 Promise 并 reject
                            );
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            console.error("\u6587\u4EF6\u6821\u9A8C\u5931\u8D25", _ctx.t0);
                            return _ctx.abrupt("return", Promise.reject(false) // 返回 Promise 并 reject
                            );
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }));
            return _beforeUpload.apply(this, arguments);
        }
        onMounted(function() {});
        return {
            uploadFileList: uploadFileList,
            uploaderAttr: uploaderAttr,
            handleChange: handleChange,
            beforeUpload: beforeUpload,
            handleFileProgress: handleFileProgress,
            handleFileSuccess: handleFileSuccess,
            handlePreview: handlePreview,
            handleFileRemoved: handleFileRemoved,
            beforeRemove: beforeRemove
        };
    }
});
